import { IndexedDB } from "../../indexDB";

// Was `signal<IndexedDB | null>(null)`, but never a reactive one: the handle is written
// once by createChatStore() at app start and every read is inside an async cache call,
// never during a render. A module-scope holder is exactly equivalent.
let chatStore: IndexedDB | null = null;

export const getChatStore = () => chatStore;

export const createChatStore = () => {
  const dbName = "chatStore";
  const dbVersion = 6;
  const dbUpgrade = (db: any) => {
    // create object stores here
    if (!db.objectStoreNames.contains("me")) {
      db.createObjectStore("me");
    }
    if (!db.objectStoreNames.contains("messages")) {
      db.createObjectStore("messages");
    }
    if (!db.objectStoreNames.contains("members")) {
      db.createObjectStore("members");
    }
    if (!db.objectStoreNames.contains("users")) {
      db.createObjectStore("users");
    }
    if (!db.objectStoreNames.contains("channelInfo")) {
      db.createObjectStore("channelInfo");
    }
    if (!db.objectStoreNames.contains("rooms")) {
      db.createObjectStore("rooms");
    }
    if (!db.objectStoreNames.contains("subscriptions")) {
      db.createObjectStore("subscriptions");
    }
  };
  // Both app open and login create it; a connection left open would block logout's delete.
  chatStore?.close();
  chatStore = new IndexedDB(dbName, dbVersion, dbUpgrade);
};

export async function getChatCache<T>(store: string, key: string) {
  try {
    // Awaited, so a failed read lands in the catch instead of rejecting the caller.
    return await chatStore?.get<T>(store, key);
  } catch {
    //    console.log("failed to get from cache", "shortcake");
    return null;
  }
}
